import Layout, { Breadcrumb } from 'components/layout'
import { Container, Input, Button } from 'components/ui'
import { useForm } from 'react-hook-form'
import { FC, useEffect, useState } from 'react'
import { useCart, useMercadinho, useNotification } from 'hooks'
import { CartCheckoutButton, CartSummary, CartListItems, CartFreight } from 'modules/cart/containers'
import Router, { useRouter } from 'next/router'
import { ROUTE_CHECKOUT } from 'routes/checkout'
import { useUserSession } from 'hooks/use-user-session'
import { ROUTE_USER_SIGN_IN } from 'routes/user'
import { Exchange } from 'components/icons'
import s from './cart.module.css'

interface CartProps {}

const Cart: FC<CartProps> = () => {
  const router = useRouter()
  const { isLoggedIn } = useUserSession()
  const { notify } = useNotification()
  const { zipCode, items, setShipping, setBlock, itemsToOrder, autoUpdateCartContext, updateCartContext } = useCart()
  useEffect(() => {
    window.localStorage.removeItem('cart_free_event')
  }, [])
  const {
    register,
    handleSubmit,
    formState: { errors, touched },
  } = useForm({
    mode: 'onChange',
  })

  function freeShippingCoupon(data: any) {
    const { coupon } = data

    // prettier/prettier
    if (coupon.toUpperCase() === '') {
      //
    } else if (coupon.toUpperCase() === 'LOGFREE' || coupon.toUpperCase() === 'SOUINTER') {
      window.localStorage.setItem('cart_free_event', 'true')
      const delivery = []
      // delivery.push({
      //   success: true,
      //   value: 0,
      //   description: 'Cupom frete grátis',
      //   freeShipping: true,
      //   sellers: [],
      //   sellersId: [],
      // })
      // setShipping(delivery)
      setBlock(false)
      notify({
        type: 'success',
        title: 'Cupom aplicado',
        description: 'O cupom foi aplicado com sucesso!',
      })
    } else {
      notify({
        type: 'danger',
        title: 'Cupom inválido',
        description: 'Cupom não foi identificado',
      })
    }
  }

  const [isSubscription, setIsSubscription] = useState(false)
  const [isExp, setIsExp] = useState(false)
  const [isMercadinho, setIsMercadinho] = useState(false)

  useEffect(() => {
    if (router.isReady) {
      const { ismercadinho } = router.query
      setIsMercadinho(ismercadinho === 'true')
    }
  }, [router.isReady, router.query])

  function hasUnselectedSubscriptionPeriod() {
    const subscriptionItems = items.filter((item) => item.assinatura === true)
    if (subscriptionItems.length === 0) return false
    return subscriptionItems.some((item) => !item.period || item.period.trim() === '')
  }

  function validateSubscriptionPeriod() {
    if (hasUnselectedSubscriptionPeriod()) {
      notify({
        type: 'danger',
        title: 'Periodicidade não selecionada',
        description: 'Selecione a periodicidade de entrega para todos os itens de assinatura antes de continuar',
      })
      return false
    }
    return true
  }

  function handleCreateOrder() {
    if (itemsToOrder.length <= 0) {
      notify({
        type: 'danger',
        title: 'Seu carrinho está vázio',
        description: 'Adicione ao menos um item ao seu carrinho',
      })
      return
    }

    if (!validateSubscriptionPeriod()) return

    let exp: boolean = true
    itemsToOrder.forEach((item) => {
      if (!item.experiencia_id || item.experiencia_id === undefined) {
        exp = false
      }
    })

    // @ts-ignore
    if (!isMercadinho && zipCode === '' && exp === false) {
      notify({
        type: 'danger',
        title: 'Preenche o CEP e clique em "calcular" para continuar',
      })
      return
    }

    if (isLoggedIn) {
      Router.push(`${ROUTE_CHECKOUT}?isMercadinho=${isMercadinho}&subscription=${isSubscription}&exp=${isExp}`)
      return
    }

    Router.push(`${ROUTE_USER_SIGN_IN}?from=${ROUTE_CHECKOUT}&subscription=${isSubscription}&exp=${isExp}`)
  }

  const crumbs = [
    {
      label: 'Carrinho de compras',
    },
  ]
  useEffect(() => {
    // identifica aqui se é assinatura
    const searchParams = new URLSearchParams(window.location.search);
    const obj = Object.fromEntries(searchParams.entries());
    console.log(obj)

    if(!obj.hasOwnProperty('subscription') && !obj.hasOwnProperty('exp')) updateCartContext('conventional');
    const { slug } = router.query
    setIsSubscription(slug === 'assinaturas')
    setIsExp(slug === 'experiencias')
  }, [router.query])

  useEffect(() => {
    if(!itemsToOrder.some(item => item.type === "convencional")) {
      setIsExp(true);
    }
  }, [itemsToOrder])

  return (
    <Layout>
      <Breadcrumb crumbs={!isMercadinho ? crumbs : []} />
      <Container>
        <h1 className={s.title}>
          Carrinho ({itemsToOrder.length}&nbsp;{itemsToOrder.length > 1 ? 'produtos' : 'produto'})
        </h1>
        <div className={s.root}>
          <div className={s.list}>
            <CartListItems subscriptionOnly={isSubscription} expOnly={isExp} key="cart-view-component" />
          </div>
          <div className={s.info}>
            {!isMercadinho && (
              <div>
                {zipCode !== undefined && zipCode !== '' && (
                  <div className={s.notification}>
                    <Exchange />
                    Para prosseguir com sua compra, realize login em sua conta.
                  </div>
                )}
              </div>
            )}
            {/* {!isMercadinho && (
              <>
                <div className={s.freightTitle}>Calcule o valor e tempo de entrega</div>
                <CartFreight key="cart-freight-component" />
              </>
            )} */}
            {isSubscription && (
              <p>
                Cancele quando quiser ou altere a periodicidade de recebimento na área do cliente
                <br />
                As assinaturas só são possíveis de serem pagas com cartão de crédito
                <br />
                <br />
              </p>
            )}
            <CartSummary row key="cart-summary-component" className={s.summary} />
            <div className={s.infoCoupon}>
              <div className={s.freightTitle}>Aplicar cupom de desconto</div>
              <form className={s.formCoupon} onSubmit={handleSubmit(freeShippingCoupon)}>
                <Input
                  type="text"
                  name="coupon"
                  error={errors.coupon?.message}
                  touched={touched?.coupon}
                  ref={register({
                    minLength: {
                      value: 4,
                      message: 'Cupom inválido',
                    },
                  })}
                  placeholder="Cupom de desconto"
                  className={s.couponInput}
                />
                <Button variant="primary" type="submit">
                  Aplicar
                </Button>
              </form>
            </div>
            <CartCheckoutButton
              label="Continuar compra"
              className={s.buttonCheckout}
              onClick={() => {
                if (!validateSubscriptionPeriod()) return
                if(isMercadinho) {
                  handleCreateOrder();
                } else if(isExp) {
                  if (isLoggedIn) Router.push(`${ROUTE_CHECKOUT}?subscription=${isSubscription}&exp=${isExp}`)
                  else Router.push(`${ROUTE_USER_SIGN_IN}?from=${ROUTE_CHECKOUT}&subscription=${isSubscription}&exp=${isExp}`)
                } else {
                  router.push(`/entrega?subscription=${isSubscription}&exp=${isExp}`)
                }
              }}
            />
          </div>
        </div>
      </Container>
    </Layout>
  )
}

export default Cart
